<script setup lang="ts">
import { PhStarFour } from '@phosphor-icons/vue'
import BaseBadge from './BaseBadge.vue'

/** Shown next to an ambassador's name. `labelled` adds the word, for profile headers. */
defineProps<{ labelled?: boolean }>()
</script>

<template>
  <BaseBadge v-if="labelled" color="amber">
    <PhStarFour weight="fill" class="mr-1 h-3 w-3" aria-hidden="true" />
    Ambassador
  </BaseBadge>
  <span
    v-else
    class="inline-flex shrink-0 items-center text-accent-amber"
    title="Ambassador"
  >
    <PhStarFour weight="fill" class="h-3.5 w-3.5" aria-hidden="true" />
    <span class="sr-only">Ambassador</span>
  </span>
</template>
